import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { WebsocketService } from 'src/app/services/websocket.service';
import { Subscription } from 'rxjs';
import { RootService } from 'src/app/services/root.service';
import { SessionService } from 'src/app/lib/shared/services/session.service';
import { filter } from 'rxjs/operators';
import { UploadInputDirective } from 'src/app/lib/shared/directives/upload-input.directive';
import { hideAnimation, showAnimation } from 'src/animations';
import { NewsfeedService } from 'src/app/lib/newsfeed/services/newsfeed.service';
import { UserService } from 'src/app/lib/user/services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.css'],
  animations: [ hideAnimation, showAnimation ]
})
export class RootComponent implements OnDestroy, OnInit {

  @ViewChild(UploadInputDirective) set uploadInput(directive: UploadInputDirective) {
    this.rootService.registerUploadInput(directive);
  }

  private _subscriptions: Subscription[] = [];

  constructor(
    private _websocket: WebsocketService,
    public rootService: RootService,
    public sessionService: SessionService,
    public newsfeedService: NewsfeedService,
    public userService: UserService
  ) { }

  ngOnDestroy() {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit() {
    this._subscriptions.push(...[
      this.sessionService.loggedIn$.pipe(filter(x => x)).subscribe(() => this._websocket.startConnection())
    ]);
  };

  @HostListener('click', ['$event'])
  @HostListener('keydown', ['$event'])
  handleUserInteraction(event: Event) {
    this.sessionService.resetAutoLoginTimer();
  }
}
